import React from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import KYCIllustration from "../../Assets/carren-verify.png";
import { FiShield, FiCheckCircle, FiUsers, FiTruck, FiBriefcase, FiFileText, FiBarChart2, FiSmartphone } from "react-icons/fi";

const LUMEKYC = () => {
  return (
    <>
      <Navbar />
      <main className="kyc-page" role="main">
      <style>{`
        .kyc-page {
          background: #ffffff;
          color: #1f2937;
          min-height: 100vh;
        }

        /* ── Hero ─────────────────────────────────────── */
        .kyc-hero {
          background: linear-gradient(135deg, #065E49 0%, #118D57 50%, #16A34A 100%);
          color: #ffffff;
          overflow: hidden;
        }

        .kyc-hero-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 4.5rem 1.5rem;
          display: flex;
          gap: 2rem;
          align-items: center;
          justify-content: space-between;
        }

        .kyc-hero-left {
          flex: 1 1 55%;
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .kyc-badge {
          display: inline-flex;
          align-items: center;
          gap: .5rem;
          background: rgba(255, 255, 255, 0.14);
          border: 1px solid rgba(255, 255, 255, 0.3);
          color: #E7F8EF;
          padding: .35rem .75rem;
          font-weight: 700;
          border-radius: 999px;
          width: fit-content;
          backdrop-filter: blur(4px);
          font-size: 0.9rem;
        }

        .kyc-badge svg {
          font-size: 1rem;
        }

        .kyc-title {
          font-size: clamp(2rem, 4.8vw, 3.25rem);
          line-height: 1.15;
          font-weight: 800;
          margin: .25rem 0 .5rem 0;
          letter-spacing: .2px;
          text-wrap: balance;
        }

        .kyc-subtitle {
          font-size: clamp(1.05rem, 2.5vw, 1.25rem);
          line-height: 1.8;
          color: #F2FFF8;
          opacity: 0.95;
          max-width: 48ch;
        }

        .kyc-hero-right {
          flex: 1 1 45%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .kyc-hero-illustration {
          width: 100%;
          max-width: 600px;
          height: auto;
          filter: drop-shadow(0 18px 36px rgba(0, 0, 0, 0.25));
          border-radius: 16px;
        }

        /* ── Features Section ─────────────────────────── */
        .kyc-section {
          max-width: 1200px;
          margin: 0 auto;
          padding: 3.5rem 1.5rem 5rem 1.5rem;
        }

        .kyc-section-header {
          margin-bottom: 2rem;
        }

        .kyc-section-title {
          font-size: clamp(1.5rem, 3.5vw, 2rem);
          font-weight: 800;
          color: #0B3B2F;
          margin: 0 0 .5rem 0;
        }

        .kyc-section-subtitle {
          font-size: 1rem;
          color: #4b5563;
          margin: .5rem 0 0 0;
          line-height: 1.6;
        }

        .kyc-section-underline {
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #118D57 0%, #5BE49B 100%);
          border-radius: 2px;
          margin-top: .75rem;
        }

        /* ── Cards ────────────────────────────────────── */
        .kyc-features-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.25rem;
          margin-top: 1rem;
        }

        .kyc-card {
          background: #ffffff;
          border: 1.5px solid rgba(17, 141, 87, 0.18);
          border-radius: 16px;
          padding: 1.75rem;
          box-shadow: 0 8px 30px rgba(6, 94, 73, 0.08);
          transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
          position: relative;
          overflow: hidden;
        }

        .kyc-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #118D57 0%, #5BE49B 100%);
          transform: scaleX(0);
          transform-origin: left;
          transition: transform .25s ease;
        }

        .kyc-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 16px 44px rgba(6, 94, 73, 0.16);
          border-color: rgba(17, 141, 87, 0.35);
        }

        .kyc-card:hover::before {
          transform: scaleX(1);
        }

        .kyc-card-icon {
          width: 48px;
          height: 48px;
          background: rgba(91, 228, 155, 0.18);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.4rem;
          color: #0B604A;
          margin-bottom: 1rem;
          transition: transform .25s ease, background .25s ease;
        }

        .kyc-card:hover .kyc-card-icon {
          transform: scale(1.1) rotate(-5deg);
          background: rgba(17, 141, 87, 0.2);
        }

        .kyc-card-subtitle {
          font-size: 0.78rem;
          color: #118D57;
          font-weight: 700;
          margin: 0 0 .4rem 0;
          text-transform: uppercase;
          letter-spacing: 0.6px;
        }

        .kyc-card-title {
          margin: 0 0 .65rem 0;
          font-size: 1.1rem;
          font-weight: 800;
          color: #063C30;
        }

        .kyc-card-description {
          line-height: 1.75;
          color: #374151;
          font-size: 0.95rem;
          margin: 0;
        }

        /* ── Highlight Banner ─────────────────────────── */
        .kyc-highlight {
          background: linear-gradient(135deg, rgba(17, 141, 87, 0.07) 0%, rgba(91, 228, 155, 0.07) 100%);
          border-radius: 16px;
          padding: 2.25rem 2.5rem;
          margin-top: 2.5rem;
          border: 1.5px solid rgba(17, 141, 87, 0.2);
          box-shadow: 0 8px 30px rgba(6, 94, 73, 0.07);
        }

        .kyc-highlight-title {
          font-size: 1.25rem;
          font-weight: 800;
          color: #0B3B2F;
          margin: 0 0 .75rem 0;
          display: flex;
          align-items: center;
          gap: .65rem;
        }

        .kyc-highlight-title svg {
          font-size: 1.4rem;
          color: #118D57;
          flex-shrink: 0;
        }

        .kyc-highlight-description {
          font-size: 1rem;
          line-height: 1.8;
          color: #374151;
          margin: 0;
        }

        /* ── Responsive ───────────────────────────────── */
        @media (max-width: 1024px) {
          .kyc-hero-inner {
            padding: 3.25rem 1.25rem;
            gap: 2rem;
          }
          .kyc-features-grid {
            grid-template-columns: 1fr 1fr;
            gap: 1.25rem;
          }
        }

        @media (max-width: 768px) {
          .kyc-hero-inner {
            flex-direction: column-reverse;
            text-align: left;
            gap: 1.5rem;
          }
          .kyc-hero-right {
            width: 100%;
          }
          .kyc-hero-illustration {
            max-width: 500px;
          }
          .kyc-features-grid {
            grid-template-columns: 1fr;
          }
          .kyc-highlight {
            padding: 1.75rem;
          }
        }
      `}</style>

      {/* Hero */}
      <section className="kyc-hero">
        <div className="kyc-hero-inner">
          <div className="kyc-hero-left">
            <span className="kyc-badge">
              <FiShield /> Fraud Prevention
            </span>
            <h1 className="kyc-title">Lume KYC Verification</h1>
            <p className="kyc-subtitle">
              Verify critical customer information from trusted government and institutional 
              databases to prevent fraud and ensure compliance. Our direct integrations with 
              official data sources provide real-time verification of identities, vehicle 
              ownership, business registrations, tax compliance, and creditworthiness — 
              protecting your lending operations end to end.
            </p>
          </div>

          <div className="kyc-hero-right">
            <img
              src={KYCIllustration}
              className="kyc-hero-illustration"
              alt="KYC verification dashboard interface"
              loading="eager"
            />
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="kyc-section" aria-label="KYC Integrations">
        <header className="kyc-section-header">
          <h2 className="kyc-section-title">Official Database Integrations</h2>
          <p className="kyc-section-subtitle">
            Instant verification through direct connections to Kenya's official government and institutional databases
          </p>
          <div className="kyc-section-underline" />
        </header>

        <div className="kyc-features-grid">
          <article className="kyc-card">
            <div className="kyc-card-icon"><FiUsers /></div>
            <p className="kyc-card-subtitle">Identity Verification</p>
            <h3 className="kyc-card-title">IPRS Check</h3>
            <p className="kyc-card-description">
              Verify customer ID numbers instantly against the Integrated Population Registration 
              System (IPRS) national database. Confirm identity authenticity and detect fraudulent 
              documents before any lending decision is made — in real-time, at the point of onboarding.
            </p>
          </article>

          <article className="kyc-card">
            <div className="kyc-card-icon"><FiTruck /></div>
            <p className="kyc-card-subtitle">Vehicle Verification</p>
            <h3 className="kyc-card-title">NTSA Check</h3>
            <p className="kyc-card-description">
              Verify vehicle registration numbers directly against the National Transport and Safety 
              Authority (NTSA) database. Confirm ownership, registration validity, and encumbrance 
              status — essential for accurate collateral assessment in asset-backed lending.
            </p>
          </article>

          <article className="kyc-card">
            <div className="kyc-card-icon"><FiBriefcase /></div>
            <p className="kyc-card-subtitle">Business Verification</p>
            <h3 className="kyc-card-title">BRS Check</h3>
            <p className="kyc-card-description">
              Verify business clients through the Business Registration Service (BRS) national 
              database. Confirm company registration status, ownership structure, and legal 
              standing — giving you reliable due diligence for every corporate lending decision.
            </p>
          </article>

          <article className="kyc-card">
            <div className="kyc-card-icon"><FiFileText /></div>
            <p className="kyc-card-subtitle">Tax Compliance</p>
            <h3 className="kyc-card-title">KRA PIN Match</h3>
            <p className="kyc-card-description">
              Cross-validate a customer's KRA PIN against their National ID number directly 
              within the Kenya Revenue Authority database. Instantly confirm that both identifiers 
              belong to the same individual — eliminating PIN spoofing, flagging discrepancies, 
              and ensuring every borrower meets tax compliance requirements before approval.
            </p>
          </article>

          <article className="kyc-card">
            <div className="kyc-card-icon"><FiBarChart2 /></div>
            <p className="kyc-card-subtitle">Credit Bureau</p>
            <h3 className="kyc-card-title">Metropol CRB Check</h3>
            <p className="kyc-card-description">
              Connect directly to Metropol, Kenya's leading Credit Reference Bureau, to retrieve 
              real-time credit scores, delinquency flags, and full borrower credit histories at 
              the point of appraisal. Every lending decision is backed by verified, up-to-date 
              credit data — reducing default risk and ensuring full regulatory compliance.
            </p>
          </article>

          <article className="kyc-card">
            <div className="kyc-card-icon"><FiSmartphone /></div>
            <p className="kyc-card-subtitle">Mobile Verification</p>
            <h3 className="kyc-card-title">Mobile Number Check</h3>
            <p className="kyc-card-description">
              Confirm that a customer's mobile number is registered under the identity details 
              they have provided, via Safaricom's Mobile Number Validation API. The check 
              verifies true number ownership, 
              preventing impersonation, and closing a common identity-fraud vector at the 
              earliest stage of onboarding.
            </p>
          </article>
        </div>

        <div className="kyc-highlight">
          <h3 className="kyc-highlight-title">
            <FiCheckCircle /> Real-Time, Government-Verified Data
          </h3>
          <p className="kyc-highlight-description">
            Every verification runs in real-time against official government and institutional databases, 
            ensuring you make lending decisions on the most current and accurate information available. 
            Reduce fraud exposure, satisfy regulatory requirements, and build lasting borrower trust — 
            with verified data at every step of your lending process.
          </p>
        </div>
      </section>
    </main>
    <Footer />
    </>
  );
};

export default LUMEKYC;
